import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center">
        <div className="bg-card/80 backdrop-blur-3xl border border-white/20 rounded-3xl p-8 shadow-2xl" style={{ backdropFilter: 'blur(40px) saturate(180%)' }}>
          <XCircle className="h-16 w-16 text-amber-500 mx-auto mb-6" />
          <h1 className="text-2xl font-bold text-foreground mb-2">Payment Cancelled</h1>
          <p className="text-foreground/70 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          
          <div className="space-y-3">
            <button
              onClick={() => navigate(-1)}
              className="w-full py-3 rounded-xl bg-electric text-background font-semibold hover:bg-electric/90 transition-all"
            >
              Try Again
            </button>
            
            <button
              onClick={() => navigate('/')}
              className="w-full py-3 rounded-xl bg-white/10 text-foreground font-semibold hover:bg-white/20 transition-all"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
